<template>
  <header :class="{ 'scrolled-nav': scrolledPosition }">
    <nav>
      <div class="branding">
        <router-link
          :to="{ name: 'Home'}"
        >
          <img
            src="@/assets/logo.svg"
            alt="logo"
          >
        </router-link>
      </div>
      <div class="icon">
        <MenuAlt3Icon
          class="menu-icon"
          :class="{'icon-active' : mobileNav}"
          style="width: 24px"
          @click="mobileNav=!mobileNav"
        />
      </div>
      <transition name="mobile-nav">
        <div
          v-show="mobileNav"
          class="backdrop"
          @click.self="mobileNav=!mobileNav"
        >
        <div v-if="role" class="profile">
          <p>Hey there {{ user.displayName }}</p>
          <!-- <p class="bio">
            Currently logged in as a {{ grade }} {{ role }} <br>
          </p> -->
        </div>
          <span
            @click="mobileNav=!mobileNav"
            class="x-out">
              &times;
          </span>
          <ul class="dropdown-nav">
            <li>
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Home'}"
              >
                Home
              </router-link>
            </li>
            <li
             v-if="role">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Announcements'}"
              >
                Notice Board
              </router-link>
            </li>
            <li
             v-if="role === 'testAdmin'">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Administration'}"
              >
                Administration
              </router-link>
            </li>
            <li
             v-if="role === 'teacher' || role === 'testAdmin'">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Teacher'}"
              >
                Teacher
              </router-link>
            </li>
            <li
             v-if="role === 'learner' || role === 'testAdmin'">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Class'}"
              >
                Class
              </router-link>
            </li>
            <li
             v-if="role">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Parents'}"
              >
                School Policies
              </router-link>
            </li>
            <li
             v-if="role === 'teacher' || role === 'testAdmin'">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Staff'}"
              >
                Staff Policies
              </router-link>
            </li>
            <li
             v-if="role">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Circulars'}"
              >
                News Bulletin
              </router-link>
            </li>
            <li
             v-if="role">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Events'}"
              >
                Events
              </router-link>
            </li>
            <li
             v-if="role">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Clubs'}"
              >
                Extra-curriculars
              </router-link>
            </li>
            <li
             v-if="role === 'learner' || role === 'testAdmin'">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Profile'}"
              >
                Profile
              </router-link>
            </li>
            <li>
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'OurSchool'}"
              >
                Our School
              </router-link>
            </li>
            <li
             v-if="!role">
              <router-link
                class="link"
                @click="mobileNav=!mobileNav"
                :to="{ name: 'Contact'}"
              >
                Contact Us
              </router-link>
            </li>
            <li
              v-if="user"
              class="link btn"
              @click="handleClick"
            >
              Logout
            </li>
            <li
              v-else
            >
            <router-link
              @click="mobileNav=!mobileNav"
              :to="{ name: 'Welcome'}"
              class="link btn">
              Login
            </router-link>
            </li>
          </ul>
        </div>
      </transition>
    </nav>
  </header>
</template>

<script>
import useLogout from '@/composables/useLogout'
import getUser from '@/composables/getUser'
import { useRouter } from 'vue-router'
import { MenuAlt3Icon } from '@heroicons/vue/outline'
import { ref } from '@vue/reactivity'

export default {
  components: { MenuAlt3Icon },
  props: {},
  setup () {
    const scrolledPosition = ref(null)
    const mobileNav = ref(false)
    const { logout, error } = useLogout()
    const { user, role, grade } = getUser()
    const router = useRouter()

    const handleClick = async () => {
      await logout()
      router.push({ name: 'Home' })
      mobileNav.value = false
    }

    return { scrolledPosition, handleClick, user, role, grade, error, mobileNav }
  }
}
</script>

<style>
header {
  z-index: 99;
  position: fixed;
  color: #fff;
  transition: 0.5s ease all;
  width: 100vw;
}
header nav {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 90%;
  padding: 0;
  margin: 0 auto;
  transition: 0.5s ease all;
}
header .branding {
  background-color: var(--inspire-gold);
}
@media(min-width: 960px) {
  header nav {
    max-width: 1080px;
  }
}
header nav ul, .link {
  list-style: none;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
}
header nav li {
  padding: 12px;
  margin-left: 16px;
  text-transform: uppercase;
}
header nav .link {
  padding-bottom: 4px;
  font-size: 14px;
  transition: 0.5s ease all;
  border-bottom: 1px solid transparent;
}
header nav .btn {
  cursor: pointer;
  border-radius: 30px;
}
header nav .link:hover {
  color: var( --sidebar-item-hover);
  border-color: var( --sidebar-item-hover);
}
header nav .branding {
  display: flex;
  align-items: center;
}
header nav .branding img {
  width: 40px;
  transition: 0.5s ease all;
}
header nav .icon{
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 24px;
  height: 100%;
}
header nav .icon .menu-icon {
  cursor: pointer;
  font-size: 24px;
  transition: 0.5s ease all;
}
header nav .icon .icon-active {
  transform: rotate(180deg);
}
header nav .dropdown-nav {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 250px;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
}
header nav .dropdown-nav li {
  margin-left: 0;
}
header nav .dropdown-nav li:nth-child(1) {
  margin-top: 90px;
}
header nav .dropdown-nav li .link{
  color: var(--inspire-charcoal);
}
header nav .dropdown-nav li.btn {
  color: var(--inspire-charcoal);
  width: 100px;
  align-self: center;
  transition: 0.5s ease all;
}
header nav .dropdown-nav li.btn:hover,
header nav .x-out:hover {
  color: var(--sidebar-item-active);
  background-color: var(--inspire-rose);
}
header nav .x-out {
  position: fixed;
  top: 5px;
  left: 200px;
  z-index: 100;
  cursor: pointer;
  color: var(--inspire-charcoal);
  width: 35px;
  transition: 0.5s ease all;
  border: 1px #FF54AC solid;
}
.mobile-nav-enter-active,
.mobile-nav-leave-active {
  transition: 1s ease all;
}
.mobile-nav-enter-from,
.mobile-nav-leave-to {
  opacity: 0;
  transform: translateX(-250%);
}
header nav .backdrop {
  top: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  width: 120%;
  height: 100%;
}
header nav .backdrop .profile {
  position: fixed;
  top: 30px;
  left: 5px;
  max-width: 250px;
  z-index: 100;
  color: var(--inspire-gold);
}
header nav .backdrop .profile .bio {
  font-size: 14px;
  color: var(--inspire-fossil);
}
nav .dropdown-nav a.router-link-active {
  color: var(--sidebar-item-hover) !important;
  border-color: var(--sidebar-item-active);
}
</style>
